import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";

/**
 * Created by Jerker Nord on 2022-04-01.
 */

export class BenjiKIVTotalWinRunner implements SimplePresentation {

    private _mainTL:gsap.core.Timeline;
    private _controller:SimplePresentationRunnerController;

    constructor() {
    }

    public shouldRun():boolean {
        if (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL){
            return (BenjiKIV.model.winRatio < this.getBigWinRatio() && BenjiKIV.model.gameData.accumulatedRoundWin > 0);
        }else{
            return (BenjiKIV.model.winRatio < this.getBigWinRatio() && BenjiKIV.model.gameData.totalSpinWinnings > 0);
        }
    }

    private getBigWinRatio():number {
        return 15;
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._controller = controller;
        const delayTL:gsap.core.Timeline = new gsap.core.Timeline({delay : 0.35});
        let winAmount:number = BenjiKIV.model.gameData.accumulatedRoundWin;
        if(BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN || BenjiKIV.model.data.mode == BenjiKIVGameMode.SUPER_FREESPIN) {
            winAmount = BenjiKIV.model.totalSpinWinnings;
        }
        if (BenjiKIV.model.gameData.brokeTheBank == true){
            winAmount = BenjiKIV.model.upToMaxWinAmount;
        }
        delayTL.add(() => {
            this._mainTL = gsap.timeline({
                onComplete : () => {
                    this.complete();
                }
            });
            if(winAmount > 0) {
                this._mainTL.add([
                    BenjiKIV.totalWinView.getTotalWinTimeline(winAmount),
                    () => this._controller.setSkipCallback(() => this.skip())
                ]);
                this._mainTL.add(()=>BenjiKIV.initialWinView.hideAndResetAllSpineAnimations());
            }
        });
    }

    private skip():void {
        BenjiKIV.totalWinView.hardAbort();
        BenjiKIV.initialWinView.hideAndResetAllSpineAnimations();
    }

    private complete():void {
        this._controller.finish();
    }
}